module.exports = __webpack_public_path__ + "static/img/plus-symbol.c42a7ed2.png";